/***
**Module Name: category
 **File Name :  category.js
 **Project :    Orasi Media
 **Copyright(c) : X Platform Consulting.
 **Organization : Peafowl Inc
 **author :  chandrasekhar
 **author :  Hari
 **license :
 **version :  1.0.0
 **Created on :
 **Created on: Dec 29 2022
 **Last modified on: Dec 29 2022
 **Description : contains category page details.
 ***/
import React, { useState, useEffect, useRef, useContext } from "react";
import tmdbApi from "../api/tmdbApi";
import { useNavigate } from "react-router";
import Footer from "../components/footer/Footer";
import Header from "../components/InnerHeader/Header";
import Modal from 'react-bootstrap/Modal';
import SweetAlert from 'react-bootstrap-sweetalert';
import * as Config from "../constants/Config"
import SessionPopup from "./SessionPopup"
import { contentContext } from "../context/contentContext"
import axios from "axios";
import moment from "moment";
import InactivePopup from "./inactivePopup";
let { lambda, appname } = window.app;



const Profile = () => {
  const navigate = useNavigate();

  //  const [menus, setMenus] = useState([]);
  const [name, setName] = useState('');
  const [emailId, setEmailId] = useState('');
  const [phonenumber, setPhonenumber] = useState('');
  const [companyName, setCompany] = useState('');
  const [companyContenttype, setCompanyContenttype] = useState('');
  const [companyMail, setCompanyMail] = useState('');
  const [companyMobile, setCompanyMobile] = useState('');
  const [companyType, setCompanyType] = useState('');
  const [config, setConfig] = useState({});
  const [clientData, setClientData] = useState([]);
  const [valid, setValid] = useState(false);
  const [phoneerror, setPhoneError] = useState('');
  const [nameerror, setNameError] = useState('');
  const [success, setSuccess] = useState(false);
  const [activeLoad, setActiveLoad] = useState("");

  const [passwordInput, setPasswordInput] = useState({
    password: '',
    confirmPassword: '',
    oldPassword: ''
  })
  const [passwordError, setPasswordErr] = useState("");
  const [oldPasswordError, setOldPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [passwordShown, setPasswordShown] = useState(false);
  const [number, setNumber] = useState(false);
  const [upper, setUpper] = useState(false);
  const [limit, setLimit] = useState(false);
  const [lower, setLower] = useState(false);
  const [special, setSpecial] = useState(false);
  const [error, setError] = useState('');
  const [compMailErr, setCompMailErr] = useState('');
  const [compPhnErr, setCompPhnErr] = useState('');
  const [showSessionPopupup, setShowSessionPopupup] = useState(false);
  const [countries, setCountries] = useState('');
  const [idc, setIdc] = useState('');
  const [IdcError, setIdcError] = useState('');
const [flag,setflag]=useState(false);
  const { menus, setContentSearchFlag, contentSearchFlag, inactiveFlag, setInactiveFlag, setClientData1, setRoute } = useContext(contentContext);

  const checkInput = (e) => {
    const onlyDigits = e.target.value.replace(/\D/g, "");
    setPhonenumber(onlyDigits);

  };

  const handleCompanyMobile = (e) => {
    const onlyDigits = e.target.value.replace(/\D/g, "");
    setCompanyMobile(onlyDigits);

  };



  useEffect(() => {
    if (!localStorage.getItem("token")) {
      navigate("/");
    }
    //  appMenus();
    GetClientDataFun();
    clientActivity();
    GetCountries();
    setContentSearchFlag(false)
    setRoute("notcontent")
  }, []);

  useEffect(() => {
    if (window.site) {
      setConfig(window.site);

    }

  }, [window.site]);
  const GetCountries = async () => {
    try {
      console.log(tmdbApi);
      const response = await tmdbApi.getLookUp({
        "type": ["country"],
        "sortBy": "alpha3"
      });

      setCountries(response.result);

    } catch {
      console.log("error");
    }
  };


  if (config.common && config.common.imagesCDN) {
    var img = config.common.imagesCDN;
  }

  const handleBack = () => {
    navigate('/content')
  }

  // console.log('local name', localStorage.getItem(""))
  const GetClientDataFun = async () => {
    try {

      const response = await tmdbApi.getClientData({});
      console.log("response", response.result);
      if (response.statusCode === 200) {
        if (response.result == "Invalid token or Expired") {
          setShowSessionPopupup(true)
        } else if (response.result === "Client inactived") {
          setInactiveFlag(true)
        } else {
          let formData = response.result.result[0]

          setName(formData.name)
          setIdc(formData.idc)
          setEmailId(formData.personalemail)
          setCompany(formData.companyname)
          setCompanyMail(formData.companyemail)
          setCompanyMobile(formData.companymobile)
          setCompanyType(formData.companytype)
          setCompanyContenttype(formData.contenttype)
          setPhonenumber(formData.personalphone)
          setClientData(response.result.result[0]);
          setClientData1(response.result.result[0])
        }
        // console.log('response client Data--->',response.result[0])
      }
    } catch {
      console.log("error");
    }
  };

  const clientActivity = () => {
    let path = window.location.pathname.split("/");
    // const pageName = path[path.length - 1];
    var presentTime = moment();
    let payload;

    payload = {
      "clientid": localStorage.getItem("clientid"),
      "pagename": 'PROFILE',
      "pageurl": window.location.href,
      "starttime": presentTime,
      "useragent": JSON.parse(localStorage.getItem("loc"))

    };


    let urlLink;
    if (localStorage.getItem("previousid")) {
      urlLink = lambda + '/activity?appname=' + appname + "&previousid=" + localStorage.getItem("previousid")
    } else {
      urlLink = lambda + '/activity?appname=' + appname
    }

    axios({
      method: 'POST',
      url: urlLink,
      data: payload
    })
      .then(function (response) {
        if (response.data.statusCode === 200) {
          localStorage.setItem("previousid", response.data.result)
        }
      });
  }


  // console.log('client dataaaaaa',clientData && clientData.companyid && clientData.companyid[0])

  const checkMailInput = (e) => {
    const onlyDigits = e.target.value.replace(/\D/g, "");
    setPhonenumber(onlyDigits);

  };

  const handleSubmit = (e) => {
    let flag = true;
    if (phonenumber.trim() === "") {
      setPhoneError("Please enter phone number");
      flag = false
      setTimeout(function () { setPhoneError("") }, 3000);
    }
    if (name.trim() === "") {
      setNameError("Please enter Name");
      flag = false
      setTimeout(function () { setNameError("") }, 3000);
    }
    if ((!phonenumber.trim() && idc.trim())) {

      setPhoneError("Enter phone number");
      setTimeout(function () { setPhoneError("") }, 3000);
      flag = false
    }


    if (phonenumber.trim() && !idc.trim()) {
      setIdcError("Select country code");
      setTimeout(function () { setIdcError("") }, 3000);
      flag = false
    }

    if (flag) {
      if (activeLoad == "") {
        updateForm();
      }
    }

  }
  // console.log('companyMail',companyMail)

  const companyFormValid = () => {
    let flag = true;
    const regEx = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,8}(.[a-zA-Z{2,8}])?/g;
    if (regEx.test(companyMail)) {
      console.log('companyMailcompanyMailcompanyMailcompanyMail1111111111111')
      setCompMailErr("");

    } else if (!regEx.test(companyMail) && companyMail !== "") {
      setCompMailErr("Email is Not Valid");
      console.log('companyMailcompanyMailcompanyMailcompanyMail22222222')

      // setTimeout(function () { setError("") }, 2000)
      flag = false;
    } else if (companyMail === "" || companyMail == undefined) {
      setCompMailErr("Please enter email");
      flag = false;
    }
    if (companyMobile === "") {
      setCompPhnErr("Please enter phone number");
      flag = false
      console.log('33333333333333333')

      setTimeout(function () { setCompPhnErr("") }, 3000);
    }
    return flag
  }
  const handleCompanySubmit = () => {
    const k = companyFormValid()
    if (k) {
      console.log('submit form')
      if (activeLoad == "") {
        updateCompanyForm()
      }
    }
  }

  function onConfirm() {
    setSuccess(false)
  };

  const updateCompanyForm = async () => {
    try {
      setActiveLoad("companyDetails")
      const response = await tmdbApi.updateCompanyData({
        "emailid": companyMail,
        "companyid": clientData && clientData.companyid && clientData.companyid[0],

        "phone": companyMobile
      });
      // console.log(response);

      if (response.statusCode == 200) {
        if (response.result == "Invalid token or Expired") {
          setShowSessionPopupup(true)
        } else if (response.result == "Client inactived") {
          setInactiveFlag(true)

        } else {
          setSuccess(true);
          setflag(true);
          GetClientDataFun();
        }
      }
      setActiveLoad("")
    } catch {
      setActiveLoad("")
      console.log("error");
    }
  };

  const updateForm = async () => {
    try {
      setActiveLoad("userDetails")
      const response = await tmdbApi.updateClientData({
        "personalphone": phonenumber,
        "name": name,
        "idc": idc
      });
      // console.log(response);

      if (response.statusCode == 200) {
        if (response.result == "Invalid token or Expired") {
          setShowSessionPopupup(true)
        } else if (response.result == "Client inactived") {
          setInactiveFlag(true)

        } else {
          setSuccess(true);
          console.log('response.result ', response?.result)
          GetClientDataFun();
        }
      }
      setActiveLoad("")
    } catch {
      setActiveLoad("")
      console.log("error");
    }
  };

  const handlePwdGenerate = (e) => {

    if (passwordInput.password == "") {
      setError("Please Enter New Password");
      setTimeout(function () { setError("") }, 4000);

    } else if (passwordInput.confirmPassword == "") {
      setError("Please Enter Confirm Password");
      setTimeout(function () { setError("") }, 4000);

    } else if (passwordInput.oldPassword == "") {
      setError("Please Enter Old Password");
      setTimeout(function () { setError("") }, 4000);

    }
    else if (passwordInput.confirmPassword !== passwordInput.password) {
      setConfirmPasswordError("Confirm password is not matched");
      // setTimeout(function () { setConfirmPasswordError("") }, 4000);
    }
    //else if(lower === false && number === false && limit === false && lower === false && special === false){
    //     setError("Please Enter Strong Password");
    //     setTimeout(function () { setError("") }, 3000);

    // }
    else if (!limit || !upper || !special || !lower || !number) {

      setError("Please enter the password as per the instructions");
      // setTimeout(function () { setError("") }, 3000);

    }
    else if (limit && upper && special && lower && number && confirmPasswordError === "") {
      setError("")
      if (passwordInput.password === passwordInput.confirmPassword) {
        setConfirmPasswordError("")
        if (activeLoad == "") {
          pwdGenerate();
        }
      }
    }
  }
  const pwdGenerate = async () => {
    try {
      setActiveLoad("changePwd")
      const response = await tmdbApi.pwdGenerate({
        "emailid": emailId,
        "password": passwordInput.password,
        "oldPassword": passwordInput.oldPassword
      });
      // console.log(response.result.token);
      if (response.result == "old password is wrong") {
        setError("old password is incorrect");
        setTimeout(function () { setError("") }, 3000);
      } else if (response.result == "Invalid token or Expired") {
        setShowSessionPopupup(true)
      } else if (response.result == "Client inactived") {
        setInactiveFlag(true)

      } else {
        if (response.result.token) {

          window.localStorage.setItem("token", response.result.token);
          //  navigate("/category")
          setSuccess(true);

        }
      }
      setActiveLoad("")
    } catch {
      setActiveLoad("")

      console.log("error");
    }
  };
  const handlePasswordChange = (evnt) => {
    const passwordInputValue = evnt.target.value.trim();
    const passwordInputFieldName = evnt.target.name;
    const NewPasswordInput = { ...passwordInput, [passwordInputFieldName]: passwordInputValue }
    console.log('NewPasswordInput', NewPasswordInput)
    setPasswordInput(NewPasswordInput);
    if (limit && upper && special && lower && number && confirmPasswordError === "") {
      setError("")
    }
  }
  const togglePassword = (e) => {
    setPasswordShown(!passwordShown);
  };
  const handleValidation = (evnt) => {
    const passwordInputValue = evnt.target.value.trim();
    const passwordInputFieldName = evnt.target.name;
    //for password 
    if (passwordInputFieldName === 'password' || passwordInputFieldName === 'oldPassword') {
      const uppercaseRegExp = /(?=.*?[A-Z])/;
      const lowercaseRegExp = /(?=.*?[a-z])/;
      const digitsRegExp = /(?=.*?[0-9])/;
      const specialCharRegExp = /(?=.*?[#?!@$%^&*-])/;
      const minLengthRegExp = /.{8,}/;
      const passwordLength = passwordInputValue.length;
      const uppercasePassword = uppercaseRegExp.test(passwordInputValue);
      const lowercasePassword = lowercaseRegExp.test(passwordInputValue);
      const digitsPassword = digitsRegExp.test(passwordInputValue);
      const specialCharPassword = specialCharRegExp.test(passwordInputValue);
      const minLengthPassword = minLengthRegExp.test(passwordInputValue);
      let errMsg = "";
      if (passwordLength === 0) {
        errMsg = "Password is empty";
      }
      if (uppercasePassword) {
        var element = document.getElementById("err1");
        element.classList.add("vaild");
        setUpper(true);
      } else {
        var element = document.getElementById("err1");
        element.classList.remove("vaild");
        setUpper(false);
      }
      if (lowercasePassword) {
        var element = document.getElementById("err");
        element.classList.add("vaild");
        setLower(true);
      } else {
        var element = document.getElementById("err");
        element.classList.remove("vaild");
        setLower(false);
      }
      if (digitsPassword) {
        var element = document.getElementById("err2");
        element.classList.add("vaild");
        setNumber(true);
      } else {
        var element = document.getElementById("err2");
        element.classList.remove("vaild");
        setNumber(false);
      }
      if (specialCharPassword) {
        var element = document.getElementById("err3");
        element.classList.add("vaild");
        setSpecial(true)
      } else {
        var element = document.getElementById("err3");
        element.classList.remove("vaild");
        setSpecial(false)
      }
      if (minLengthPassword) {
        var element = document.getElementById("err4");
        element.classList.add("vaild");
        setLimit(true)
      } else {
        var element = document.getElementById("err4");
        element.classList.remove("vaild");
        setLimit(false)
      }
      if (passwordInputFieldName === 'password') {
        setPasswordErr(errMsg);
      } else {
        setOldPasswordError(errMsg)
      }

      if (limit && upper && special && lower && number && confirmPasswordError === "") {
        setError("")
      }

    }

  }
  const handleAddclass = (evnt) => {
    var element = document.getElementById("instruction");
    element.classList.add("ins-dsp-none");
    setConfirmPasswordError("");
  }
  const handleRemoveclass = (evnt) => {
    var element = document.getElementById("instruction");
    element.classList.remove("ins-dsp-none");
  }
  const handleConfirm = (evnt) => {
    const passwordInputFieldName = evnt.target.name;
    if (passwordInputFieldName === "confirmPassword" || (passwordInputFieldName === "password")) {

      if (passwordInput.confirmPassword !== passwordInput.password) {
        setConfirmPasswordError("Confirm password is not matched");
      } else {
        setConfirmPasswordError("");
      }

    }
  }
  let myArray = []
  myArray = clientData && clientData.name?.split(" ");

  return (
    <>
      <Header activeClass={"9"} />
      {inactiveFlag && <InactivePopup />}
      {!inactiveFlag && showSessionPopupup && <SessionPopup />}




      <div className="inner-body profile" id="profile-page">
        <div className="body-header" id="profile-header">
          <div className="md-container">
            <div className="page-header">
              <div className="block-title">
                <h2 id="profile-title">Profile</h2>
              </div>
              <button
                className="plain-btn"
                id="back-button"
                onClick={handleBack}
              >
                <span className="material-icons-outlined">chevron_left</span>
                Back
              </button>
            </div>
          </div>
        </div>

        <div className="md-container">
          <div className="card-block mt-3" id="user-details-section">
            <div className="row profile-pic">
              <div className="col-lg-8 col-md-8 col-xs-12">
                <h3 id="user-details-title">User Details</h3>

                {/* Name */}
                <div className="form-group mb-3">
                  <label htmlFor="user-name-input" className="form-label">
                    Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="user-name-input"
                    placeholder="Enter Name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                  {nameerror ? (
                    <span className="errormsg" id="user-name-error">
                      {nameerror}
                    </span>
                  ) : (
                    ""
                  )}
                </div>

                {/* Email */}
                <div className="form-group mb-3">
                  <label htmlFor="user-email-input" className="form-label">
                    Email Id
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="user-email-input"
                    value={emailId}
                    disabled
                  />
                </div>

                {/* Country + Phone */}
                {/* <div className="form-floating mb-3 country-dropdown">
                    <select
                      name="idc"
                      value={idc}
                      id="country-code-select"
                      className="colorselect capitalize"
                      onChange={(e) => setIdc(e.target.value)}
                    >
                      <option value="">select</option>
                      {countries &&
                        countries.length > 0 &&
                        countries.map((task, i) => (
                          <option key={i} value={task.alpha3}>
                            {task.alpha3 + task.countrycode}
                          </option>
                        ))}
                    </select>
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="user-phone-input"
                        value={phonenumber}
                        name="phone"
                        onChange={(e) => checkInput(e)}
                      />
                      <label htmlFor="user-phone-input">Contact Number</label>
                      <span className="errormsg" id="country-code-error">
                        {IdcError}
                      </span>
                      {phoneerror ? (
                        <span className="errormsg" id="user-phone-error">
                          {phoneerror}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  </div> */}

                {/* old */}

                <div id="phone-block" className="mb-3 custom-drop_down field-set">
                  <label htmlFor="phone-number" className="form-label">
                    Contact Number
                  </label>
                  <div className="d-flex">
                    <select
                      name="idc"
                      value={idc}
                      id="country-code-select"
                      className="form-select colorselect capitalize"
                      onChange={(e) => setIdc(e.target.value)}
                      style={{ maxWidth: "120px" }}
                    >
                      <option value="">select</option>
                      {countries &&
                        countries.length > 0 &&
                        countries.map((task, i) => (
                          <option key={i} value={task.alpha3}>
                            {task.alpha3 + task.countrycode}
                          </option>
                        ))}
                    </select>

                    <input
                      type="text"
                      className="field form-control"
                      placeholder="Enter Phone Number"
                      id="user-phone-input"
                      value={phonenumber}
                      name="phone"
                      onChange={(e) => checkInput(e)}
                    />
                  </div>
                  <span className="errormsg" id="country-code-error">
                    {IdcError}
                  </span>
                  {phoneerror ? (
                    <span className="errormsg" id="user-phone-error">
                      {phoneerror}
                    </span>
                  ) : (
                    ""
                  )}
                </div>


                {/* Submit Button */}
                <button
                  className="fill_btn yellow-gradient"
                  id="user-update-btn"
                  onClick={(e) => handleSubmit(e)}
                >
                  {activeLoad === "userDetails" ? (
                    <img
                      src={
                        img + "orasi/client/resources/orasiv1/images/common-icons/rotate_right.svg"
                      }
                      className="loading-icon"
                      id="user-update-loader"
                    />
                  ) : null}
                  Update
                </button>
              </div>

              {/* Avatar Section */}
              <div className="col-lg-4 col-md-4 col-xs-12">
                <div className="avatar-block" id="avatar-section">
                  <div className="avatar-header">
                    <div className="avatar-img-block">
                      <p id="avatar-initials">
                        {myArray && myArray.length > 1
                          ? myArray[0]?.slice(0, 1)?.toUpperCase() +
                          myArray[1]?.slice(0, 1)?.toUpperCase()
                          : clientData && clientData.name?.slice(0, 2)?.toUpperCase()}
                      </p>
                    </div>
                  </div>
                  <div className="avatar-body">
                    <h6 className="username mt-3" id="avatar-username">
                      {clientData.name}
                    </h6>
                    <p className="lg-badge badge" id="avatar-type">
                      {clientData && clientData.type
                        ? clientData.type == "BOTH"
                          ? "BUYER, SELLER"
                          : clientData.type
                        : "BUYER"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card-block my-3" id="company-details-section">
            <div className="col-lg-8 col-md-8 col-xs-12">
              <h3 id="company-details-title">Company Details</h3>

              {clientData && clientData.companyname ? (
                <div className="form-group mb-3">
                  <label htmlFor="company-name-input" className="form-label">
                    Company Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="company-name-input"
                    value={companyName}
                    disabled
                  />
                </div>
              ) : null}

              <div className="form-group mb-3">
                <label htmlFor="company-email-input" className="form-label">
                  Company Email Id
                </label>
                <input
                  type="email"
                  className="form-control"
                  id="company-email-input"
                  value={companyMail}
                  onChange={(e) => setCompanyMail(e.target.value)}
                />
                {compMailErr ? (
                  <span className="errormsg" id="company-email-error">
                    {compMailErr}
                  </span>
                ) : (
                  ""
                )}
              </div>

              <div className="form-group mb-3">
                <label htmlFor="company-phone-input" className="form-label">
                  Company Phone Number
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="company-phone-input"
                  value={companyMobile}
                  name="Companyphone"
                  onChange={(e) => handleCompanyMobile(e)}
                />
                {compPhnErr ? (
                  <span className="errormsg" id="company-phone-error">
                    {compPhnErr}
                  </span>
                ) : (
                  ""
                )}
              </div>

              <div className="form-group mb-3">
                <label htmlFor="company-type-input" className="form-label">
                  Company Type
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="company-type-input"
                  value={companyType}
                  name="companyType"
                  disabled
                />
              </div>

              {clientData && clientData.contenttype ? (
                <div className="form-group mb-3">
                  <label htmlFor="company-contenttype-input" className="form-label">
                    Content Type
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="company-contenttype-input"
                    value={companyContenttype}
                    disabled
                  />
                </div>
              ) : null}

              <button
                className="fill_btn yellow-gradient"
                id="company-update-btn"
                onClick={(e) => handleCompanySubmit(e)}
              >
                {activeLoad === "companyDetails" ? (
                  <img
                    src={
                      img + "orasi/client/resources/orasiv1/images/common-icons/rotate_right.svg"
                    }
                    className="loading-icon"
                    id="company-update-loader"
                  />
                ) : null}
                Update
              </button>
            </div>

          </div>

          <div className="card-block my-3" id="change-password-section">
            <div className="row">
              <div className="col-lg-7 col-md-7 col-xs-12">
                <h3 id="change-password-title">Change Password</h3>

                <div className="form-group mb-3">
                  <label htmlFor="old-password-input" className="form-label">
                    Old Password<span>*</span>
                  </label>
                  <input
                    type={passwordShown ? "text" : "password"}
                    value={passwordInput.oldPassword}
                    onChange={(e) => handlePasswordChange(e)}
                    name="oldPassword"
                    placeholder="Old Password"
                    className="form-control"
                    id="old-password-input"
                  />
                  <span className="errormsg" id="old-password-error">
                    {oldPasswordError}
                  </span>
                </div>

                <div className="form-group mb-3">
                  <label htmlFor="new-password-input" className="form-label">
                    New Password<span>*</span>
                  </label>
                  <input
                    type={passwordShown ? "text" : "password"}
                    value={passwordInput.password}
                    onChange={(e) => handlePasswordChange(e)}
                    onKeyUp={handleValidation}
                    name="password"
                    placeholder="Password"
                    className="form-control"
                    id="new-password-input"
                    onBlur={(e) => handleAddclass(e)}
                    onFocus={(e) => handleRemoveclass(e)}
                  />
                  <span className="errormsg" id="new-password-error">
                    {passwordError}
                  </span>
                </div>

                <div className="form-group mb-3">
                  <label htmlFor="confirm-password-input" className="form-label">
                    Confirm Password<span>*</span>
                  </label>
                  <input
                    type={passwordShown ? "text" : "password"}
                    value={passwordInput.confirmPassword}
                    onChange={(e) => handlePasswordChange(e)}
                    onKeyUp={handleConfirm}
                    onBlur={(e) => handleAddclass(e)}
                    onFocus={(e) => handleRemoveclass(e)}
                    name="confirmPassword"
                    placeholder="Password"
                    className="form-control"
                    id="confirm-password-input"
                  />
                  <span className="errormsg" id="confirm-password-error">
                    {confirmPasswordError}
                  </span>
                </div>

                <div className="flex-left terms-block">
                  <input
                    type="checkbox"
                    id="show-password-checkbox"
                    onChange={(e) => togglePassword(e)}
                  />
                  <label htmlFor="show-password-checkbox"> Show Password.</label>
                </div>

                <span className="errormsg" id="password-generic-error">
                  {error}
                </span>

                <div className="signin-footer mt-4">
                  <button
                    className="fill_btn yellow-gradient"
                    id="change-password-btn"
                    onClick={(e) => handlePwdGenerate(e)}
                  >
                    {activeLoad === "changePwd" ? (
                      <img
                        src={
                          img +
                          "orasi/client/resources/orasiv1/images/common-icons/rotate_right.svg"
                        }
                        className="loading-icon"
                        id="change-password-loader"
                      />
                    ) : null}
                    Change Password
                  </button>
                </div>
              </div>

              <div className="col-lg-5 col-md-5 col-xs-12">
                <div className="create-password" id="password-instructions-block">
                  <div className="crpsd-cnt-blk">
                    <div
                      className="create-password-instruction ins-dsp-none"
                      id="instruction"
                    >
                      <p className="error" id="err" data-testid="error-lowercase">
                        {lower ? (
                          <span className="material-symbols-outlined">check</span>
                        ) : (
                          <span className="material-symbols-outlined">close</span>
                        )}
                        Password must contain a lower case letter
                      </p>

                      <p className="error" id="err1" data-testid="error-uppercase">
                        {upper ? (
                          <span className="material-symbols-outlined">check</span>
                        ) : (
                          <span className="material-symbols-outlined">close</span>
                        )}
                        Password must contain an upper case letter
                      </p>

                      <p className="error" id="err2" data-testid="error-number">
                        {number ? (
                          <span className="material-symbols-outlined">check</span>
                        ) : (
                          <span className="material-symbols-outlined">close</span>
                        )}
                        Password must contain a number
                      </p>

                      <p className="error" id="err3" data-testid="error-special">
                        {special ? (
                          <span className="material-symbols-outlined">check</span>
                        ) : (
                          <span className="material-symbols-outlined">close</span>
                        )}
                        Password must contain a special character or a space
                      </p>

                      <p className="error" id="err4" data-testid="error-length">
                        {limit ? (
                          <span className="material-symbols-outlined">check</span>
                        ) : (
                          <span className="material-symbols-outlined">close</span>
                        )}
                        Password must contain at least 8 characters
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>



      <Footer menus={menus} />
      <SweetAlert show={success}
        custom
        confirmBtnText="Ok"
        confirmBtnBsStyle="primary"
        title={"Updated successfully"}
        onConfirm={e => onConfirm()}
        customButtons={
    <a
      id={flag?"company-alert-ok-btn":"user-alert-ok-btn"}
      href="#"
      className="btn btn-lg btn-primary"
      onClick={onConfirm}
    >
      Ok
    </a>
  }
      >
      </SweetAlert>
    </>
  );
};

export default Profile;
